import type { Conf, Dept } from './global';
import { getZe } from './util';

const waitForDepartment = (
    switchChat: (online: boolean) => void,
    waitCount: number,
    conf: Conf,
) => {
    const zE = getZe();

    if (waitCount-- < 0) {
        throw conf.waitError('Wait paid department timeout');
    }
    const dptInit = zE('webWidget:get', 'chat:department', conf.department);
    if (!!dptInit && dptInit.status) {
        zE('webWidget:on', 'chat:departmentStatus', (dept: Dept) => {
            if (dept.name === conf.department) {
                switchChat(dept.status === 'online');
            }
        });
        switchChat(dptInit.status === 'online');
    } else {
        setTimeout(() => waitForDepartment(switchChat, waitCount, conf), 300);
    }
};

export default waitForDepartment;
